<template>
  <div id="onboarding-sidebar" class="flex items-start w-full lg:h-full">
    <aside class="flex flex-col items-start px-8 py-6 lg:p-16 lg:h-screen w-full">
        <router-link :to="{ name: 'Project' }" tag="a" class="focus:outline-none focus:shadow-outline flex items-center space-x-4 underline text-gray-500 hover:text-gray-600 transition duration-150">

            <icon-svg icon="thin-arrow-left" class="w-4"/>

            <span class="leading-none">Skip quick set up</span>

        </router-link>

        <nav class="hidden lg:block mt-32 w-full">
            <ul class="space-y-6 w-full">
                <router-link tag="li" :to="{ name: item.route }" v-for="(item, index) in navigationItems"
                class="py-3 px-4 rounded-lg flex items-center font-semibold cursor-pointer transition duration-300"
                :class="{
                    'text-primary bg-primary bg-opacity-10': index < currentNavigationIndex,
                    'text-gray-600 bg-gray-100 dark:bg-gray-700 dark:text-gray-200': index === currentNavigationIndex,
                    'text-gray-500 bg-gray-100 opacity-50 dark:bg-gray-900 dark:text-gray-600': index > currentNavigationIndex,
                }" 
                
                :key="item.name">

                    <icon-svg icon="tick" class="w-5 mr-4"/>

                    {{ item.name }}
                </router-link>
            </ul>
        </nav>
    </aside>

    <span class="hidden lg:block border-r border-gray-300 mt-40" style="height: 600px"></span>
  </div>
</template>

<script>
export default {
    data() {
        return {
            navigationItems: [
                {
                    name: "Create your project",
                    route: "Onboarding"
                },
                {
                    name: "Update your profile",
                    route: "OnboardingUpdateProfile"
                },
                {
                    name: "Invite your team",
                    route: "OnboardingInviteTeam"
                },
            ]
        }
    },
    computed: {
        currentNavigationIndex () {
            const currentRoute = this.$route.name;
            const isCurrentItem = (item) => item.route == currentRoute;
            return this.navigationItems.findIndex(isCurrentItem);
        },
    }
}
</script>

<style scoped>
#onboarding-sidebar {
  max-width: 450px;
}

#onboarding-sidebar li {
    max-width: 300px;
}

@media (max-width: 1080px) {
  #onboarding-sidebar {
    max-width: none;
  }
}
</style>
